module.exports = __webpack_public_path__ + "img/loading-tasks.cfba05cb.png";